import { Modal, Button } from 'react-bootstrap';
import { AlertTriangle } from 'lucide-react';

const ConfirmModal = ({
    show = false,
    onHide,
    onConfirm,
    onDeny,
    title = "Confirmar acción",
    message = "¿Estás seguro de que deseas continuar?",
    confirmText = "Confirmar",
    confirmVariant = "danger",
    denyText = "No",
    cancelText = "Cancelar",
    isLoading = false,
    children = null,
}) => {
    const handleConfirm = () => {
        if (onConfirm) {
            onConfirm();
        }
    };

    return (
        <Modal show={show} onHide={onHide} centered>
            {/* Encabezado con icono y botón de cierre */}
            <Modal.Header closeButton>
                <Modal.Title className="d-flex align-items-center">
                    <AlertTriangle className="text-warning me-2" size={24} />
                    {title}
                </Modal.Title>
            </Modal.Header>
            {/* Mensaje de confirmación */}
            <Modal.Body>
                <p className="mb-0">{message}</p>
                {children}
            </Modal.Body>
            {/* Pie con acciones:
            - Cancelar: cierra el modal sin efectos secundarios.
            - (Opcional) No / Deny: acción alternativa si `denyText` es truthy.
            - Confirmar: acción principal, deshabilitado durante carga. */}
            <Modal.Footer>
                <Button
                    variant="outline-secondary"
                    onClick={onHide}
                    disabled={isLoading}
                >
                    {cancelText}
                </Button>

                {denyText && (
                    <Button variant="danger" onClick={onDeny} disabled={isLoading}>
                        {denyText}
                    </Button>
                )}

                <Button
                    variant={confirmVariant}
                    onClick={handleConfirm}
                    disabled={isLoading}
                >
                    {isLoading ? 'Procesando...' : confirmText}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ConfirmModal;